import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import s from "../clinic.module.css";

export default function ClubLifePostActionSheet({
  post,
  open,
  busy = false,
  onClose,
  onEdit,
  onDelete,
}) {
  const [confirmDelete, setConfirmDelete] = useState(false);

  useEffect(() => {
    if (open) setConfirmDelete(false);
  }, [open, post?.id]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape" && !busy) onClose?.();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, busy, onClose]);

  if (!open || !post) return null;

  const handleDelete = () => {
    if (confirmDelete) {
      onDelete?.(post);
      return;
    }
    setConfirmDelete(true);
  };

  return createPortal(
    <div
      className={s.postActionSheetOverlay}
      role="dialog"
      aria-modal="true"
      onClick={() => !busy && onClose?.()}
    >
      <div
        className={s.postActionSheet}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={s.postActionSheetHandle} aria-hidden />

        {confirmDelete ? (
          <>
            <p className={s.postActionSheetWarn}>
              Удалить запись? Это действие нельзя отменить.
            </p>
            <button
              type="button"
              className={`${s.postActionSheetBtn} ${s.postActionSheetBtnDanger}`}
              onClick={handleDelete}
              disabled={busy}
            >
              {busy ? "Удаляем…" : "Удалить запись"}
            </button>
            <button
              type="button"
              className={s.postActionSheetBtn}
              onClick={() => setConfirmDelete(false)}
              disabled={busy}
            >
              Назад
            </button>
          </>
        ) : (
          <>
            <button
              type="button"
              className={s.postActionSheetBtn}
              onClick={() => onEdit?.(post)}
              disabled={busy}
            >
              Редактировать
            </button>
            <button
              type="button"
              className={`${s.postActionSheetBtn} ${s.postActionSheetBtnDanger}`}
              onClick={handleDelete}
              disabled={busy}
            >
              Удалить
            </button>
          </>
        )}

        <button
          type="button"
          className={`${s.postActionSheetBtn} ${s.postActionSheetBtnCancel}`}
          onClick={onClose}
          disabled={busy}
        >
          Отмена
        </button>
      </div>
    </div>,
    document.body,
  );
}
